import React from 'react';
import type { FD110 } from '../../../services/d211Api';

interface Tab3Props {
  formData: Partial<FD110>;
  names: Record<string, string>;
  isEditing: boolean;
  setField: (key: string, value: unknown) => void;
  resolveSingleName: (nameKey: string, type: string, code: string) => void;
}

const Tab3Remarks: React.FC<Tab3Props> = React.memo(({ formData, names, isEditing, setField, resolveSingleName }) => {
  const disabled = !isEditing;

  return (
    <div className="d211-tab-content">
      <div className="form-section">
        <label className="section-label">SHIPPING MARK</label>
        <textarea className="form-textarea large"
          value={formData.fd110_41 || ''}
          onChange={e => setField('fd110_41', e.target.value)}
          disabled={disabled}
          rows={6} />
      </div>

      <div className="form-section">
        <div className="form-grid">
          <label>備註代號</label>
          <div className="lookup-field">
            <input className="form-input" style={{ width: 80 }} value={formData.fd110_421 || ''}
              onChange={e => setField('fd110_421', e.target.value)}
              onBlur={() => resolveSingleName('remarkTemplate', 'remarkTemplate', formData.fd110_421 || '')}
              disabled={disabled} />
            <span className="lookup-name">{names.remarkTemplate || ''}</span>
          </div>
        </div>
        <label className="section-label">備註 內容</label>
        <textarea className="form-textarea large"
          value={formData.fd110_42 || ''}
          onChange={e => setField('fd110_42', e.target.value)}
          disabled={disabled}
          rows={6} />
      </div>

      <div className="form-section">
        <div className="form-grid">
          <label>品質要求代號</label>
          <div className="lookup-field">
            <input className="form-input" style={{ width: 80 }} value={formData.fd110_44 || ''}
              onChange={e => setField('fd110_44', e.target.value)}
              onBlur={() => resolveSingleName('qualityCode', 'qualityCode', formData.fd110_44 || '')}
              disabled={disabled} />
            <span className="lookup-name">{names.qualityCode || ''}</span>
          </div>
        </div>
        <label className="section-label">品質要求內容</label>
        <textarea className="form-textarea large"
          value={formData.fd110_441 || ''}
          onChange={e => setField('fd110_441', e.target.value)}
          disabled={disabled}
          rows={6} />
      </div>
    </div>
  );
});

Tab3Remarks.displayName = 'Tab3Remarks';
export default Tab3Remarks;
